var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 1920 1080",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i0"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.568s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 0; 0",
    keyTimes: "0; 0.191489; 0.446809; 0.702128; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,540)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.398,1.398)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.568s",
    begin: "0s",
    calcMode: "spline",
    values: "1.398 1.398; 1.398 1.398; 5.351 5.351; 7.853 7.853; 7.853 7.853",
    keyTimes: "0; 0.191489; 0.446808; 0.702128; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,45.25,-60.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 7.75,
    rx: 7.75,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,-46.75,-50.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 6.25,
    rx: 6.25,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,-50.25,41.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 7.25,
    rx: 7.25,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,54.25,32.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 5.75,
    rx: 5.75,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,-56.5,9.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3,
    rx: 3,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,55,-14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3.5,
    rx: 3.5,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,-4.25,-61.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3.25,
    rx: 3.25,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,-0.25,58.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3.75,
    rx: 3.75,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i9"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.568s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 0; 0",
    keyTimes: "0; 0.191489; 0.446809; 0.702128; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,540)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9,0.9)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.568s",
    begin: "0s",
    calcMode: "spline",
    values: "0.9 0.9; 0.9 0.9; 4.404 4.404; 5.549 5.549; 5.549 5.549",
    keyTimes: "0; 0.191489; 0.446808; 0.702128; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i10",
    transform: "matrix(1,0,0,1,89.5,-14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-7.28C0,-7.28,2.14,-2.945,2.14,-2.945C2.14,-2.945,6.924,-2.25,6.924,-2.25C6.924,-2.25,3.462,1.125,3.462,1.125C3.462,1.125,4.279,5.89,4.279,5.89C4.279,5.89,0,3.64,0,3.64C0,3.64,-4.279,5.89,-4.279,5.89C-4.279,5.89,-3.462,1.125,-3.462,1.125C-3.462,1.125,-6.924,-2.25,-6.924,-2.25C-6.924,-2.25,-2.14,-2.945,-2.14,-2.945C-2.14,-2.945,0,-7.28,0,-7.28Z",
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11",
    transform: "matrix(1,0,0,1,-82,-12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-8.602C0,-8.602,2.528,-3.48,2.528,-3.48C2.528,-3.48,8.181,-2.658,8.181,-2.658C8.181,-2.658,4.09,1.329,4.09,1.329C4.09,1.329,5.056,6.959,5.056,6.959C5.056,6.959,0,4.301,0,4.301C0,4.301,-5.056,6.959,-5.056,6.959C-5.056,6.959,-4.09,1.329,-4.09,1.329C-4.09,1.329,-8.181,-2.658,-8.181,-2.658C-8.181,-2.658,-2.528,-3.48,-2.528,-3.48C-2.528,-3.48,0,-8.602,0,-8.602Z",
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12",
    transform: "matrix(1,0,0,1,-3.5,-91.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-5.523C0,-5.523,1.623,-2.234,1.623,-2.234C1.623,-2.234,5.253,-1.707,5.253,-1.707C5.253,-1.707,2.626,0.853,2.626,0.853C2.626,0.853,3.246,4.468,3.246,4.468C3.246,4.468,0,2.761,0,2.761C0,2.761,-3.246,4.468,-3.246,4.468C-3.246,4.468,-2.626,0.853,-2.626,0.853C-2.626,0.853,-5.253,-1.707,-5.253,-1.707C-5.253,-1.707,-1.623,-2.234,-1.623,-2.234C-1.623,-2.234,0,-5.523,0,-5.523Z",
    fill: "#783a99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13",
    transform: "matrix(1,0,0,1,2.5,81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-8.602C0,-8.602,2.528,-3.48,2.528,-3.48C2.528,-3.48,8.181,-2.658,8.181,-2.658C8.181,-2.658,4.09,1.329,4.09,1.329C4.09,1.329,5.056,6.959,5.056,6.959C5.056,6.959,0,4.301,0,4.301C0,4.301,-5.056,6.959,-5.056,6.959C-5.056,6.959,-4.09,1.329,-4.09,1.329C-4.09,1.329,-8.181,-2.658,-8.181,-2.658C-8.181,-2.658,-2.528,-3.48,-2.528,-3.48C-2.528,-3.48,0,-8.602,0,-8.602Z",
    fill: "#783a99"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i14"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.568s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0.8; 0; 0",
    keyTimes: "0; 0.297872; 0.574468; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,535.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.568s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 5.3 5.3; 4.31 4.31; 5.35 5.35; 5.35 5.35",
    keyTimes: "0; 0.297872; 0.446809; 0.574468; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.75,4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,-60.75,-4.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 61.25,
    rx: 61.25,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i15"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.568s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0.81; 1; 1",
    keyTimes: "0; 0.297872; 0.574468; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,535.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.413,0.413)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.568s",
    begin: "0s",
    calcMode: "spline",
    values: "0.413 0.413; 5.325 5.325; 4.133 4.133; 5.088 5.088; 5.088 5.088",
    keyTimes: "0; 0.297872; 0.446809; 0.574468; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,-62,-4.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 40,
    rx: 40,
    cy: 0,
    cx: 0,
    fill: "#783a99"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.763,0,0,3.763,961.141,540)",
    id: "i16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i17"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 12,
    stroke: "#ffffff",
    d: "M-23,-3.5"
  }, /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.4671337814403852s",
    to: "M-23,-3.5",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.5005004801146984s",
    to: "M-23,-3.5C-23,-3.5,-22.732,-3.232,-22.266,-2.766",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.5338671787890117s",
    to: "M-23,-3.5C-23,-3.5,-21.872,-2.372,-20.225,-0.725",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.5672338774633249s",
    to: "M-23,-3.5C-23,-3.5,-20.278,-0.778,-17.115,2.385",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.6006005761376382s",
    to: "M-23,-3.5C-23,-3.5,-17.6,1.9,-13.175,6.325",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.6339672748119514s",
    to: "M-23,-3.5C-23,-3.5,-12.223,7.277,-8.642,10.858",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.6673339734862646s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,-6.026,10.526,-3.753,8.253",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.7007006721605779s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,-3.619,8.119,1.253,3.247",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.734067370834891s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,-0.737,5.237,6.142,-1.642",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.7674340695092042s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,2.606,1.894,10.675,-6.175",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.8008007681835175s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,6.403,-1.903,14.615,-10.115",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.8341674668578307s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,10.651,-6.151,17.725,-13.225",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.867534165532144s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,15.35,-10.85,19.766,-15.266",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "0.9009008642064572s",
    to: "M-23,-3.5C-23,-3.5,-7.5,12,-7.5,12C-7.5,12,20.5,-16,20.5,-16",
    attributeName: "d"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i18"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.568s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.574468; 0.787234; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(664.641,864) scale(1,1) translate(0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#00ff97",
    dominantBaseline: "middle",
    textAnchor: "start",
    fontWeight: 700,
    fontSize: 64,
    fontFamily: "SFUIDisplay-Bold, Arial, sans-serif"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7d9ce5ce6c73d394149703cc51cc146d.svg";
export { ForwardRef as ReactComponent };